/**
 * Created by henian.xu on 2018/2/2.
 * 弹出框组件
 */

import Vue from 'vue';
import { isVNode, Dom } from 'utils';
import main from './main';

const MainConstructor = Vue.extend(main);
let instance;
let loadingInstance;
let currentMsg;
const msgQueue = [];
const defaults = {
    show: false,
    showCancelBtn: false,
    cancelBtnText: '取消',
    showConfirmBtn: true,
    confirmBtnText: '确认',

    errorText: '',

    showInput: false,
    inputValue: '',
    inputMaxlength: null,
    placeholder: '请输入',
    inputAutoSize: { maxRows: 4 },

    closeTime: 2000,
    closeTimer: 0,

    delayConfirm: 0,
    delayConfirmTimer: 0,

    isClickOtherClose: true,
    validCallback: null, // 此方法必须返回 Promise

    action: '',
    showCloseBtn: false,
    // callback: null,
};

let popupWrap;
function createMountNode() {
    if (!popupWrap) {
        // TODO #app 是不确定的，应该另想方法
        popupWrap = Dom.getPopupWrap(document.querySelector('#app'));
    }
    const node = document.createElement('div');
    popupWrap.appendChild(node);
    return node;
}

const defaultCallback = action => {
    if (!currentMsg) return;
    const cbFn = currentMsg.callback;
    if (typeof cbFn === 'function') {
        if (instance.showInput) {
            cbFn(instance.inputValue, action);
        } else {
            cbFn(action);
        }
    }
    const { resolve } = currentMsg;
    const { reject } = currentMsg;
    if (resolve) {
        if (action === 'confirm') {
            if (instance.showInput) {
                resolve(instance.inputValue, action);
            } else {
                resolve(action);
            }
        } else if ((action === 'cancel' || action === 'close') && reject) {
            reject(action);
        }
    }
};

function initInstance() {
    return new MainConstructor({});
}

function showNextMsg() {
    if (!instance) {
        instance = initInstance();
    }
    instance.action = '';
    const isInBody = instance.$el && document.body.compareDocumentPosition(instance.$el) !== 20;
    if ((instance.show && !isInBody) || !msgQueue.length) return;
    currentMsg = msgQueue.shift();
    const { options } = currentMsg;
    Object.keys(options).forEach(key => {
        // if (!hasOwn(instance, key)) return;
        instance[key] = options[key];
    });

    // 如果没有 callback 选用 Promise
    if (options.callback === undefined) {
        instance.callback = defaultCallback;
    }
    const oldCbFn = instance.callback;
    instance.callback = (action, instance_) => {
        oldCbFn(action, instance_);
        Vue.prototype.$nextTick(() => showNextMsg());
    };

    if (isVNode(instance.message)) {
        instance.$slots.default = [instance.message];
        instance.message = null;
    } else {
        delete instance.$slots.default;
    }
    if (isVNode(instance.title)) {
        instance.$slots.header = [instance.title];
        instance.title = null;
    } else {
        delete instance.$slots.header;
    }

    if (!instance.$el) {
        instance.$mount(createMountNode());
    } else if (isInBody) {
        createMountNode().appendChild(instance.$el);
    }
    instance.show = true;
}

function showLoadingMsg(options) {
    if (loadingInstance) return null;
    loadingInstance = initInstance();
    Object.keys(options).forEach(key => {
        loadingInstance[key] = options[key];
    });
    loadingInstance.$mount(createMountNode());
    loadingInstance.callback = () => {};
    loadingInstance.show = true;
    return async () => {
        loadingInstance.doClose();
        await loadingInstance.$nextTick();
        const el = loadingInstance.$el;
        const { parentElement } = el;
        loadingInstance.$destroy();
        loadingInstance = null;
        setTimeout(() => {
            parentElement.removeChild(el);
        }, 500);
    };
}

function MessageBox(options, callBack) {
    if (Vue.prototype.$isServer) return Promise.resolve();
    let cbFn = callBack;
    if (options.callback && !cbFn) {
        cbFn = options.callback;
    }
    if (typeof Promise !== 'undefined') {
        return new Promise((resolve, reject) => {
            msgQueue.push({
                options: {
                    ...defaults,
                    ...MessageBox.defaults,
                    ...options,
                },
                callback: cbFn,
                resolve,
                reject,
            });
            Vue.nextTick(() => showNextMsg());
        });
    }
    msgQueue.push({
        options: {
            ...defaults,
            ...MessageBox.defaults,
            ...options,
        },
        callback: cbFn,
    });
    Vue.prototype.$nextTick(() => showNextMsg());
}

MessageBox.noTag = true;
MessageBox.names = 'messageBox';
MessageBox.defaults = {};

MessageBox.setDefaults = defaults_ => {
    MessageBox.defaults = defaults_;
};

MessageBox.alert = (message, title = '温馨提示', options) => {
    let opt = options;
    let label = title;
    if (typeof title === 'object' && !isVNode(title)) {
        opt = title;
        label = '';
    }
    return MessageBox({
        title: label,
        message,
        $type: 'alert',
        ...opt,
    });
};
MessageBox.confirm = (message, title = '温馨提示', options) => {
    let opt = options;
    let label = title;
    if (typeof title === 'object' && !isVNode(title)) {
        opt = title;
        label = '';
    }
    return MessageBox({
        title: label,
        message,
        $type: 'confirm',
        showCancelBtn: true,
        ...opt,
    });
};
MessageBox.prompt = (message, title = '温馨提示', options) => {
    let opt = options;
    let label = title;
    if (typeof title === 'object' && !isVNode(title)) {
        opt = title;
        label = '';
    }
    return MessageBox({
        title: label,
        message,
        $type: 'prompt',
        showCancelBtn: true,
        showInput: true,
        ...opt,
    });
};
MessageBox.tips = (message, options) =>
    MessageBox({
        message,
        $type: 'tips',
        ...options,
    });
MessageBox.loading = (message, options) =>
    showLoadingMsg({
        message,
        $type: 'loading',
        isClickOtherClose: false,
        ...options,
    });
MessageBox.clearQueue = () => {
    if (instance) instance.show = false;
    msgQueue.length = 0;
};

export default MessageBox;
export { MessageBox };
